import { connect } from 'react-redux';
import {
  getUsers,
  clearSession,
  syncUserData,
} from '../../store/actions/user.actions';
import BaseRouter from './base.router';

const mapStateToProps = (state) => ({
  user: state.users.session,
});
const mapDispatchToProps = {
  clearSession,
  getUsers,
  syncUserData,
};
export default connect(mapStateToProps, mapDispatchToProps)(BaseRouter);
